'use strict';

function fSliderCalendar () {
    var oSlider = document.querySelector('.js-slider-calendar');
    var oSliderList = oSlider.querySelector('.linkblock__calendar__list');
    var aSlides = oSlider.querySelectorAll('.linkblock__calendar__item');
    var aTimerItems = oSlider.querySelectorAll('.linkblock__calendar__timer__item');
    var iCurrentIndex = 0;
    var iNextIndex = 1;
    var oCurrentSlide;
    var oNextSlide;
    var iSliderHeight = aSlides[0].offsetHeight;

    // Calculate height after page is done loading
    for (var a = 0; a < aSlides.length; a += 1) {
        if (aSlides[a].offsetHeight > iSliderHeight) {
            iSliderHeight = aSlides[a].offsetHeight;
        }

        aSlides[a].style.height = '100%';
    }

    oSlider.style.height = iSliderHeight + 'px';
    
    function fSwitchGlobals () {
        var iTempNext = iNextIndex;
        iCurrentIndex = iTempNext;
        iNextIndex = (iCurrentIndex === (aSlides.length - 1)) ? 0 : iTempNext + 1;
    }

    aTimerItems[iCurrentIndex].classList.add('is-active');

    setInterval(function fAnimate() {
        var oTimeline = new TimelineLite();

        // Set slides
        oCurrentSlide = aSlides[iCurrentIndex];
        oNextSlide = aSlides[iNextIndex];

        // Set active on timer item
        aTimerItems[iCurrentIndex].classList.remove('is-active');
        aTimerItems[iNextIndex].classList.add('is-active');
        
        // Set timeline defaults
        TweenLite.defaultEase = Quart.easeInOut;
        oTimeline.timeScale(0.75);
        
        // Play animation
        oTimeline.set(oNextSlide, {
            y: '100%'
        })
        .to(oCurrentSlide, 1, {
            y: '-100%'
        })
        .to(oNextSlide, 1, {
            y: '0%',
            onComplete: fSwitchGlobals
        }, 0);
    }, 5000);
}